<template>
  <BaseNotification v-if="isShowEduYearlyNotification">
    <p class="mr-4">
      <span
        v-html="$i18nPresenter.t('annualBillingNotification', {
          date: couponExpiryDate
        })"
      >
      </span>
    </p>
    <aha-button
      variant="warning"
      class="md:ml-auto flex-grow-0 flex-shrink-0 h-6 my-2 sm:-mt-0.5 sm:mb-0"
      @click="upgrade()"
    >
      {{ $i18nPresenter.t('Learn more…') }}
    </aha-button>
  </BaseNotification>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import Utils from '@/util'
import BaseNotification from './BaseNotification.vue'

export default {
  components: {
    BaseNotification,
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapState({
      isShowEduYearlyNotification: () => {
        return false
      },
      currentPlan: (state) => state.plan,
    }),
    couponExpiryDate() {
      return moment().locale('en').endOf('month').format('DD MMMM')
    },
  },
  methods: {
    upgrade() {
      if (this.currentPlan.group !== 'edu') return
      Utils.mixpanelTracking(Utils.getGACategories(this.$route.name), 'Edu Yearly Notification bar > Click Learn more', this.currentPlan.type)
      this.$router.push({
        name: 'UserPlan',
        query: {
          planGroup: 'educational',
        },
      })
    },
  },
}
</script>

<style>

</style>
